import { Injectable } from "@angular/core";

import { CommonState } from "../state";

import { OmsMessage, OmsMessageStatus, OmsUserSettings } from "./oms.model";

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable({
	providedIn: "root",
})
export class OmsSelector {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetAlerts)
	 * OR
	 * document.obgEventBus.retrieve(AccountAppValue.PollAlerts) instead
	 */
	getAlerts() {
		return (state: CommonState): OmsMessage[] => state.oms.alerts;
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getAlertsContext() {
		return (state: CommonState): string => state.oms.alertContext;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.PollNotificationsInfo)
	 * OR
	 * document.obgEventBus.retrieve(AccountAppValue.GetNotificationsInfo) instead
	 */
	getUnreadNotificationCount() {
		return (state: CommonState): number => state.oms.notificationsInfo.unreadNotificationCount || 0;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.PollNotificationsInfo)
	 * OR
	 * document.obgEventBus.retrieve(AccountAppValue.GetNotificationsInfo) instead
	 */
	getUnreadProactiveChatCount() {
		return (state: CommonState): number => state.oms.notificationsInfo.unreadProactiveChatCount || 0;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetOmsUserSettings) instead
	 */
	getUserSettings() {
		return (state: CommonState): OmsUserSettings => state.oms.userSettings;
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	isAlertRealtimeEnabled() {
		return (state: CommonState): boolean => state.oms.isAlertRealtimeEnabled;
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	isNotificationInfoRealtimeEnabled() {
		return (state: CommonState): boolean => state.oms.isNotificationInfoRealtimeEnabled;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetOmsIsBusy) instead
	 */
	isBusy() {
		return (state: CommonState): boolean => state.oms.isBusy;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetNotificationsByStatus) instead
	 */
	getNotificationsByStatus(status: OmsMessageStatus = OmsMessageStatus.Active) {
		return (state: CommonState) => state.oms.notificationsByStatus[status];
	}
}
